/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_TitleInputs */

const en_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom RAG Knowledge Assistants`)
};

const ar_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساعدو معرفة RAG مخصصون`)
};

const bn_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাস্টম RAG নলেজ অ্যাসিস্ট্যান্ট`)
};

const de_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuelle RAG-Wissensassistenten`)
};

const es_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistentes de conocimiento RAG a medida`)
};

const fr_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistants de connaissance RAG sur mesure`)
};

const pt_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistentes de conhecimento RAG à medida`)
};

const zh_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定制 RAG 知识助手`)
};

const tr_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel RAG Bilgi Asistanları`)
};

const ru_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кастомные RAG-ассистенты знаний`)
};

const pl_svc_rag_knowledge_assistants_title = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szyte na miarę asystenty wiedzy RAG`)
};

/**
* | output |
* | --- |
* | "Custom RAG Knowledge Assistants" |
*
* @param {Svc_Rag_Knowledge_Assistants_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_title = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_title(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_title(inputs)
	return en_svc_rag_knowledge_assistants_title(inputs)
});
export { svc_rag_knowledge_assistants_title as "svc_rag-knowledge-assistants_title" }